import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url, type = 'website', noindex = false, jsonLd, children }) => {
  const siteName = 'TopInfo Rwanda';
  const defaultDesc = 'Find the best services and products in Rwanda. Book trusted professionals, buy & sell products, and grow your business on TopInfo - Rwanda\'s #1 marketplace.';
  const defaultImg = 'https://topinfo.rw/og-image.png';

  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Find Services & Products`;
  const desc = description || defaultDesc;
  const img = image || defaultImg;
  const canonical = url || (typeof window !== 'undefined' ? window.location.href : 'https://topinfo.rw');

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />}
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_RW" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      <meta name="twitter:site" content="@topinforw" />

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
      {children}
    </Helmet>
  );
};

export default SEO;
